import _ from 'lodash';

const winnerStatus = {
  ENTRY:         '',
  WINNER:        '00w',
  FIRST_PLACE:   '01w',
  SECOND_PLACE:  '02w',
  THIRD_PLACE:   '03w',
  FOURTH_PLACE:  '04w',
  FIFTH_PLACE:   '05w',
  SIXTH_PLACE:   '06w',
  SEVENTH_PLACE: '07w',
  EIGHTH_PLACE:  '08w',
  NINTH_PLACE:   '09w',
  TENTH_PLACE:   '10w',
  RUNNER_UP:     'ru',
  FINALIST:      'fn',
};

winnerStatus.ALL = _.values(winnerStatus);

export default winnerStatus;
